import pkg from '../package.json';
import {
  COOKIE_NAME,
  COOKIE_DOMAIN,
  CONFIG_NAMESPACE,
  DEFAULTS
} from './constants';
import Detector from './detector';

const config = {};

_extend(config, DEFAULTS, window.__VOONTO__.lookup(CONFIG_NAMESPACE), {
  userType:    window.__VOONTO__.getUserType(),
  device:      window.__VOONTO__.lookup('vocento.__PROVIDER__.adbd.deviceType'),
  countryCode: window.__VOONTO__.lookup('vocento.__PROVIDER__.adbd.geo.countryCode')
});

new Detector(config);

export const VERSION = pkg.version;

export const Cookie = {
  NAME:   COOKIE_NAME,
  DOMAIN: COOKIE_DOMAIN
};

/* Private */

function _extend() {
  for (var i = 1; i < arguments.length; i++) {
    Object.keys(arguments[i]).forEach((key) => {
      arguments[0][key] = arguments[i][key];
    });
  }

  return arguments[0];
}



// WEBPACK FOOTER //
// ./src/index.js